// HeaderStats.tsx
import React from 'react';
import { formatCurrency } from '../../../../../../../../../../../../utils/functions';
import { PaymentTransactionSummary } from '../../../../../../types';
import { 
     FaReceipt, 
     FaDollarSign, 
     FaCheckCircle,
     FaBan, } from 'react-icons/fa';
import './HeaderStats.scss';

interface HeaderStatsProps {
  transactionSummary: PaymentTransactionSummary | null;
  showBalances?: boolean;
}

const HeaderStats: React.FC<HeaderStatsProps> = ({
  transactionSummary,
  showBalances = true,
}) => {

  const statsData = [
    {
      icon: FaReceipt,
      value: !showBalances ? "***" : transactionSummary?.total_transactions,
      label: "Transacciones",
      color: "orange"
    },
    {
      icon: FaDollarSign,
      value: !showBalances ? "***" : formatCurrency(transactionSummary?.total_amount || 0),
      label: "Total",
      color: "orange"
    },
    {
      icon: FaCheckCircle,
      value: !showBalances ? "***" : transactionSummary?.total_approved,
      label: "Aprobadas",
      color: "orange"
    },
    {
      icon: FaBan,
      value: !showBalances ? "***" : transactionSummary?.total_cancelled,
      label: "Canceladas",
      color: "danger"
    }
  ];

  return (
    <div className="arqueo-caja-transaction-overview">
      <div className="stats-grid">
        {statsData.map((stat, index) => (
          <div key={index} className={`stat-card ${stat.color}`}>
            <div className="stat-header">
              <div className="stat-icon-container">
                <stat.icon className="stat-icon" />
              </div>
              <div className="stat-content">
                <div className="stat-value">{stat.value}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

};

export default HeaderStats;
